export default __webpack_public_path__ + "static/FuturaBT-Bold-eca9987230b6a1121f28c9b0403e1630.eot";